module.exports = __webpack_public_path__ + "static/media/spark.d212db1d.png";